import { render } from "./ImagensAnalise.vue?vue&type=template&id=3dfcf4a0"
import script from "./ImagensAnalise.vue?vue&type=script&lang=js"
export * from "./ImagensAnalise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__